export default {
    productkubun: '品名分類№',
    kubunname: '品名分類名',
    memo: 'メモ',
    sortno: '表示並び順'
};
